<template>
    <q-page padding>
        <div class="row justify-center">
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-5">
                <q-card class="q-py-xl bg-white">
                    <q-card-title class="text-center login-form">
                        <img :src="login_logo" />
                    </q-card-title>

                    <q-card-separator />
                    
                    <q-card-main class="q-pa-sm" v-if="register_others.recover_password_with_sms">
                        <q-stepper class="row q-px-sm" ref="stepper" contractable alternative-labels flat>

                            <q-step class="col-12" name="user_email" :title="$t('email')" icon="far fa-paper-plane">
                                <p>{{ $t('recover_your_password_using_your_email')}}</p>
                                <q-input lower-case v-model="user_email" :float-label="$t('email')" @keyup.enter.native="recoverPassword()" :error="$v.user_email.$error" @input="$v.user_email.$touch" />
                                <div class="col-12 q-mt-md row justify-end">
                                    <vue-recaptcha
                                        class="q-mb-sm"
                                        @verify="onVerifyRecaptcha"
                                        @expired="onExpiredRecaptcha"
                                        ref="recaptcha"
                                        :loadRecaptchaScript="false"
                                        :sitekey="getSiteKeyRecaptcha"
                                    ></vue-recaptcha>
                                </div>

                                <q-btn color="primary" class="full-width q-mt-md" icon="far fa-paper-plane" :label="$t('send_recovery_mail')" @click="recoverPassword()" />

                                
                                <div class="row gutter-sm justify-end q-mt-sm">
                                    <q-stepper-navigation>
                                        <q-btn @click="() => (currentStep = 'user_phone', $refs.stepper.next())" :label="$t('recover_by_sms')" />
                                    </q-stepper-navigation>
                                </div>
                            </q-step>

                            <q-step class="col-12" name="user_phone" :title="$t('mobile_phone')" active-icon="fas fa-mobile-alt" icon="fas fa-mobile-alt" @click="currentStep = 'user_phone'">
                                <p class="q-mb-xs">{{ $t('recover_your_password_using_your_phone_number') }}<q-icon name="fas fa-mobile-alt" class="q-ml-md" size="xl" style="font-size: 1.5em; transform: rotate(20deg);" /></p>
                                <q-input v-model="user_document"
                                    :float-label="$t('document_cpf')"
                                    @keyup.enter.native="user_document && user_document.length > 7 ?getPhoneByDocument() : ''"
                                    @input="user_document && user_document.length > 7 ?getPhoneByDocument() : ''"
                                    :error="$v.user_document.$error" />

                                <div v-if="user_document_found && !phone_mismatch">
                                    <p class="q-mt-sm">
                                        {{ $t('we_have_found_the_phone_number') }}
                                        <strong>{{ received_phone }}</strong>
                                        {{ $t('for_the_document_registered')}}
                                    </p>
                                    <p>{{ $t('if_this_is_your_phone_confirm_below') }}</p>

                                    <q-input v-model="user_phone" :float-label="$t('phone_type_info')" @keyup.enter.native="sendPhoneNumber()" :error="$v.user_phone.$error" @input="$v.user_phone.$touch" />

                                    <q-btn color="primary" class="full-width q-mt-md" icon="far fa-comment-alt" :label="$t('send_recovery_code')" @click="sendPhoneNumber()" />
                                </div>

                                <div v-if="user_document_not_found && user_document && user_document.length >= 8 && !phone_mismatch">
                                    <p class="q-mt-sm">
                                        {{ $t('we_have_not_found_the_phone_number') }}
                                        {{ $t('for_the_document_registered')}}
                                    </p>
                                    <p>{{ $t('please_check_your_document')}}</p>
                                    <p style="cursor: pointer;" class="full-width" @click="$router.push({ name: 'login-help' })"><strong>{{ `${$t('need_help')}?` }}</strong></p>
                                </div>

                                <div v-if="phone_mismatch">
                                    <p class="q-mt-md">
                                        <strong>{{ $t('phone_mismatch_you_will_be_redirected') }}</strong>
                                    </p>
                                </div>

                                <div class="row gutter-sm justify-start q-mt-sm">
                                    <q-stepper-navigation>
                                        <q-btn @click="() => (currentStep = 'user_email', $refs.stepper.previous())" :label="$t('back')" />
                                    </q-stepper-navigation>
                                </div>
                            </q-step>

                            <q-step class="col-12" name="code_confirmation" :title="$t('code')" active-icon="fas fa-barcode" icon="fas fa-barcode">
                                <div>
                                    <p class="q-mb-xs">{{ $t('insert_the_code_you_received_on_your_phone') }}<q-icon name="fas fa-mobile-alt" class="q-ml-sm" size="xl" style="font-size: 1.5em; transform: rotate(20deg);" /></p>

                                    <q-input v-model="confirmation_code" :float-label="$t('recovery_code')" debounce="1000" @keyup.enter.native="confirmCode()" @input="confirmation_code.length >= 6 ? confirmCode(): ''" />

                                    <q-btn color="primary" class="full-width q-mt-md" icon="far fa-paper-plane" :label="$t('send_recovery_code')" @click="confirmCode()" />

                                    <p v-if="!code_mismatch" class="q-mt-md" @click="sendPhoneNumber()">
                                        {{ `${$t('code_not_received')}?` }}
                                        <strong><span style="cursor: pointer;">{{ $t('resend_recovery_code') }}<q-icon name="fas fa-sms" class="q-ml-sm" size="xl" style="font-size: 1.2em;" /></span></strong>
                                    </p>

                                    <div v-if="code_mismatch">
                                        <p v-if="code_mismatch" class="q-mt-md"
                                        @click="() => (confirmation_code = '', code_mismatch = false, sendPhoneNumber())">
                                            {{ $t('recovery_code_mismatch') }}
                                            <strong><span style="cursor: pointer;">{{ $t('resend_recovery_code') }}<q-icon name="fas fa-sms" class="q-ml-sm" size="xl" style="font-size: 1.2em;" /></span></strong>
                                        </p>

                                        <div class="row gutter-sm justify-start q-mt-sm">
                                            <q-stepper-navigation>
                                                <q-btn @click="() => (currentStep = 'user_email', $refs.stepper.previous(), $refs.stepper.previous())" :label="$t('back')" />
                                            </q-stepper-navigation>
                                        </div>
                                    </div>

                                </div>
                            </q-step>

                        </q-stepper>
                    </q-card-main>

                    <q-card-main v-else>
                        <q-input lower-case v-model="user_email" :float-label="$t('email')" @keyup.enter.native="recoverPassword()" :error="$v.user_email.$error" @input="$v.user_email.$touch" />
                        
                        <div class="col-12 q-mt-md row justify-center">
                            <vue-recaptcha
                                class="q-mb-sm"
                                @verify="onVerifyRecaptcha"
                                @expired="onExpiredRecaptcha"
                                ref="recaptcha"
                                :loadRecaptchaScript="false"
                                :sitekey="getSiteKeyRecaptcha"
                            ></vue-recaptcha>
                        </div>
                        <q-btn color="primary" class="full-width q-mt-md" icon="fas fa-key" :label="$t('recover_password')" @click="recoverPassword()" />
                    </q-card-main>

                    <q-card-separator />

                    <q-card-actions>
                        <q-btn color="tertiary" class="full-width q-my-sm" icon="fas fa-chevron-left" :label="$t('back')" @click="$router.push({ name: 'login' })" />
                    </q-card-actions>
                </q-card>
                <div class="text-right q-pa-sm">
                    <p style="cursor: pointer;" class="full-width" @click="$router.push({ name: 'login-help' })">{{ $t('help') }}</p>
                </div>
            </div>
        </div>

        <q-dialog v-model="show_error" @ok="show_error = false" :cancel="false">
            <span slot="title">{{ $t('recover_password_error') }}</span>

            <span slot="message">{{ $t('user_not_found_or_incorrect') }}</span>
        </q-dialog>

        <q-dialog v-model="show_success" @ok="recoverPasswordSuccess()" :cancel="false">
            <span slot="title">{{ $t('recover_password') }}</span>

            <span slot="message">{{ $t('email_sent_recover_information') }}</span>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'quasar'
import { required, requiredIf, minLength, email } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "login"] },

    data() {
        return {
            user_email: '',
            user_document: '',
            user_document_found: false,
            user_document_not_found: null,
            user_phone: '',
            show_error: false,
            show_success: false,
            phone_mismatch: false,
            code_mismatch: false,
            origin: '',
            confirmation_code: '',
            currentStep: 'user_email',
            received_phone: '',
            original_received_phone: '',
            user_id: null,
            recaptcha_token: null
        }
    },

    computed: {
        ...mapGetters({
            login_logo: 'params/login_logo',
            login_default_language_id: 'params/login_default_language_id',
            languages: 'params/languages',
            register_others: 'params/register',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json'
                }
            }
        },

        clientName() {
            return process.env.PROJECT_FOLDER
        },

        getSiteKeyRecaptcha() {
			return process.env.GOOGLE_RECAPCHA_KEY
		},
    },

    methods: {
        recoverPassword() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let language = this.languages.find(l => {
                    return l.code.split('-')[0] === this.$i18n.i18next.language
                })

                let fd = new FormData()
                fd.append('user_email', this.user_email)
                fd.append('language', language ? language.id : this.login_default_language_id)
                fd.append('recaptcha_token', this.recaptcha_token)

                if (this.origin === '') {
                    this.$axios.post('/etraining_login/api_recover_password/', fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.show_success = true
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        this.show_error = true
                        console.log(e)
                    })
                }
                else if (this.origin === 'pop-trade') {
                    this.$axios.post('/webservices/academiapoptrade/forgot_password/', fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.show_success = true
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        this.show_error = true
                        console.log(e)
                    })
                }
                else if (this.origin === 'seven-trade') {
                    this.$axios.post('/webservices/academiaseventrade/forgot_password/', fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.show_success = true
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        this.show_error = true
                        console.log(e)
                    })
                }
            }
        },

        onVerifyRecaptcha(token) {
			this.recaptcha_token = token
		},

		onExpiredRecaptcha() {
			this.recaptcha_token = null
		},

        getPhoneByDocument() {
            const wait = debounce(() => {
                this.checkDocument()
            }, 1500)
            wait()
        },

        async checkDocument() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('document', this.user_document)

                try {
                    const response = await this.$axios.post('/etraining_login/get_phone_number_with_document/', fd, this.getHeader)

                    if (response.data.phone) {
                        this.user_id = response.data.user_id
                        this.user_document_found = true
                        this.user_document_not_found = false
                        this.original_received_phone = response.data.phone.replace(/\D/g, '')
                        this.received_phone = `XX-XXXX-${response.data.phone.slice(-4)}`
                        this.$q.loading.hide()
                    } else {
                        this.user_document_found = false
                        this.user_document_not_found = true
                        this.$q.loading.hide()
                    }
                } catch (error) {
                    this.user_document_found = false
                    this.user_document_not_found = true
                    this.$q.loading.hide()
                }
            }
        },

        async sendPhoneNumber() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()
                this.user_phone = this.user_phone.replace(/\D/g, '')
                const phoneReceived = this.original_received_phone.replace(/\D/g, '')

                try {
                    if (this.user_phone.slice(-4) === phoneReceived.slice(-4)) {
                        let fd = new FormData()
                        fd.append('phone', this.user_phone)
                        fd.append('user_id', this.user_id)

                        const response = await this.$axios.post('/etraining_login/send_code_by_sms/', fd, this.
                        getHeader)

                        console.log('response', response)

                        if (response.status === 202) {
                            this.$q.notify({
                                message: this.$t('recovery_code_sent'),
                                type: 'positive',
                                icon: 'fas fa-sms',
                                position: 'top',
                            })
                            this.currentStep = 'code_confirmation'
                            this.$refs.stepper.next()
                        }

                        this.$q.loading.hide()
                    } else {
                        this.phone_mismatch = true
                        this.user_document_found = false
                        this.$q.loading.hide()

                        setTimeout(() => {
                            this.$router.push({ name: 'login-help' })
                        }, 5000)
                    }
                } catch (error) {
                    console.log(error)
                    this.$q.loading.hide()
                }
            }
        },

        async confirmCode() {
            this.$q.loading.show()

            try {
                if (this.confirmation_code.length >= 5) {

                    let fd = new FormData
                    fd.append('code', this.confirmation_code)
                    fd.append('user_id', this.user_id)

                    const response = await this.$axios.post('/etraining_login/validate_code_sended_by_sms/', fd, this.getHeader)

                    if (response.status === 202) {
                        this.code_mismatch = false
                        this.$q.loading.hide()
                        this.$q.notify({
                                message: this.$t('recovery_code_confirmed_successfully'),
                                type: 'positive',
                                icon: 'fas fa-sms',
                                position: 'top',
                            })
                        setTimeout(() => {
                            this.$router.push(
                                { name: 'set-new-password', params: { username: response.data.username, uidb64: response.data.uidb64, token: response.data.token }
                                })
                        }, 1500)
                    }
                }
            } catch (error) {
                console.log(error)
                this.code_mismatch = true
                this.$q.loading.hide()
            }

        },

        recoverPasswordSuccess() {
            this.show_success = false
            this.$router.push({ name: 'login' })
        }
    },

    validations() {
        return {
            user_email: {
                requiredIf: requiredIf(() => {
                        if(!this.register_others.recover_password_with_sms) {
                            return  true
                        } else if(this.register_others.recover_password_with_sms && this.currentStep === 'user_phone' || this.register_others.recover_password_with_sms && this.user_document.length) {
                            return false
                        } else return true
                    })
            },
            user_document: {
                requiredIf: requiredIf(() => {
                        if(this.register_others.recover_password_with_sms && this.currentStep === 'user_phone') {
                            return true
                        } else false
                    })
            },
            user_phone: {
                requiredIf: requiredIf(() => {
                        if(this.register_others.recover_password_with_sms && this.currentStep === 'user_phone') {
                            return false
                        } else false
                    })
            }
        }
    },

    created() {
        console.log('register_others', this.register_others)
        if (this.$route.name === 'recover-password-pop-trade') this.origin = 'pop-trade'
        else if (this.$route.name === 'recover-password-pop-trade') this.origin = 'seven-trade'

        if (this.$route.params.email && this.$route.params.email.length) this.user_email = this.$route.params.email
        if (this.$route.params.document && this.$route.params.document.length) this.user_document = this.$route.params.document
        if (!this.user_email && this.user_document) this.getPhoneByDocument()
    }
}
</script>

<style lang="stylus" scoped>
.login-form
    & img
        max-width 100%
</style>
